import { StorageManager } from '@speeki/storage-manager';

import {
    TenantByUuidDocument,
    TenantByUuidQuery,
    TenantByUuidQueryVariables,
} from '@graphql/generated/graphql';

import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { currentLanguageVar, tenantModulesVar } from '@boot/reactiveVariables';
import { REACT_APP_APP_DOMAIN } from '@shared/constants';

interface UseTenantByUuidProps
    extends QueryHookOptions<TenantByUuidQuery, TenantByUuidQueryVariables> {}
/**
 * Do not change 'network-only' policy, query have to be always up-to-date and update cache.
 */
export const useTenantByUuid = ({ variables, ...rest }: UseTenantByUuidProps) =>
    useQuery(TenantByUuidDocument, {
        // TODO: check if necessary
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: ({ tenant }) => {
            tenantModulesVar(tenant.modules);
        },
        onError: () => {
            StorageManager.removeValue('tenantUuid');
            window.location.href = `${window.location.protocol}//${REACT_APP_APP_DOMAIN}`;
        },
        variables: {
            uuid: variables?.uuid ?? '',
            targetLanguage: currentLanguageVar(),
        },
        ...rest,
    });
